import { z } from 'zod'

export const Card = z.object({
  cardName: z.string(),
  fieldValues: z.record(z.union([z.string(), z.number(), z.undefined()])),
})
export type Card = z.infer<typeof Card>
